import React from "react";

import {ApolloProvider} from "@apollo/client";
import {Outlet} from "react-router-dom";
import {apolloClient} from "services/HttpService";
import "./styles.scss"

const MeasurementDevicesRoot = () => {
  return (
    <ApolloProvider client={apolloClient}>
      <Outlet/>
    </ApolloProvider>
  );

}

export default MeasurementDevicesRoot;